import React from 'react';
export const SacredBackground: React.FC = () => <div className="absolute inset-0 pointer-events-none overflow-hidden" data-id="element-51">
    {/* Layered gradient */}
    <div className="absolute inset-0" style={{
    background: 'radial-gradient(ellipse at 20% 20%, rgba(107,91,149,0.18), transparent 50%),' + 'radial-gradient(ellipse at 80% 30%, rgba(212,175,122,0.12), transparent 50%),' + 'radial-gradient(ellipse at 50% 100%, rgba(168,197,224,0.1), transparent 60%)'
  }} data-id="element-52" />

    {/* Sacred geometry SVG - flower of life inspired */}
    <svg className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-[0.06]" width="900" height="900" viewBox="0 0 900 900" fill="none" data-id="element-53">
      <g stroke="#D4AF7A" strokeWidth="0.8" data-id="element-54">
        {Array.from({
        length: 7
      }).map((_, ring) => Array.from({
        length: 6 + ring * 6
      }).map((_, i) => {
        const angle = i / (6 + ring * 6) * Math.PI * 2;
        const r = (ring + 1) * 55;
        const cx = 450 + Math.cos(angle) * r;
        const cy = 450 + Math.sin(angle) * r;
        return <circle key={`${ring}-${i}`} cx={cx} cy={cy} r="55" data-id="element-55" />;
      }))}
        <circle cx="450" cy="450" r="55" data-id="element-56" />
      </g>
    </svg>
  </div>;